import constants from "../constants/constants"
export default function Testimonials() {
    return (
        <div className="max-w-[1300px] mx-auto px-[5%] ">


            <div className="h-2 w-32 bg-logo-pink ml-4 "></div>
            <h3 className="text-4xl text-black py-8 font-mont uppercase mt-6">Testimonials</h3>

            <div className="pl-4 mt-8 pb-8">
                {constants.TESTIMONIALS.map((client)=>

                <div className="flex flex-col md:flex-row gap-x-12 gap-y-6 mb-10">
                    <div className="w-32 rounded-full h-w-32 overflow-hidden self-start">
                        <img className="w-full h-full object-cover" src={client.photo} alt="" />

                    </div>
                    <div className="flex flex-col gap-4 justify-center ml-3 md:ml-0">
                        <h4 className="text-black text-2xl">{client.name}</h4>
                        <p className="mt-1 font-semibold text-slate-500 max-w-2xl">{client.quote}</p>
                    </div>
                </div>
                )}
            </div>
        </div>
    )
}